export type ButtonType = 'PRIMARY' | 'SECONDARY' | 'DISABLED' | 'WARN';
